<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex justify-content-end my-1">
        <b-button variant="primary" :to="{ name: 'purchaseinvoice-add' }">
          <span class="text-nowrap">Create Purchase Invoice</span>
        </b-button>
        <!-- <b-button variant="primary" class="ml-2" :to="{ name: 'lowstock-list' }">
          <span class="text-nowrap">Low Stock Refill</span>
        </b-button> -->
      </div>
    </b-col>
    <b-col cols="12" md="2" sm="2" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"  />
      </b-form-group>
    </b-col>

    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <div v-if="loading || warehouseLoading || supplierLoading" class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage"
        :items="filteredPurchaseInvoices" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">

        <template #head(orderNumber)>
          <div class="d-flex flex-column">
            <span>Order Number</span>
            <b-form-input v-model="filters.orderNumber" placeholder="Filter by Order Number" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Supplier Name -->
        <template #head(supplierName)>
          <div class="d-flex flex-column">
            <span>Supplier Name</span>
            <b-form-input v-model="filters.supplierName" placeholder="Filter by Supplier Name" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Filter input for Warehouse Name -->
        <template #head(warehouseName)>
          <div class="d-flex flex-column">
            <span>Warehouse Name</span>
            <b-form-input v-model="filters.warehouseName" placeholder="Filter by Warehouse Name" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <template #head(status)>
          <div class="d-flex flex-column">
            <span>Status</span>
            <b-form-select v-model="filters.status" :options="statusOptions" size="sm" @change="filterTable"
              placeholder="Filter by Status" />
          </div>
        </template>
        <template #head(issueDate)>
          <div class="d-flex flex-column">
            <span>Issue Date</span>
            <DatePicker v-model="filters.issueDate" range placeholder="Select Date Range" size="sm"
              @change="filterTable" :clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
              class="small-datepicker" />
          </div>
        </template>

        <!-- Filter input for Created On -->
        <template #head(createdOn)>
          <div class="d-flex flex-column">
            <span>Created On</span>
            <DatePicker v-model="filters.createdOn" range placeholder="Select Date Range" size="sm"
              @change="filterTable" :clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
              class="small-datepicker" />
          </div>
        </template>



        <template #cell(orderNumberr)="data">
          {{ data.item.OrderNumber }}
        </template>
        <template #cell(supplierName)="data">
          {{ data.item.supplierName }}
        </template>
        <template #cell(warehouseName)="data">
          {{ data.item.warehouseName }}
        </template>
        <template #cell(createdOn)="data">
          {{ formatDate(data.item.createdOn) }}
        </template>
        <template #cell(issueDate)="data">
          {{ formatDate(data.item.issueDate) }}
        </template>
        <template #cell(total)="data">
          Rs {{ data.item.total.toFixed(2) }}
        </template>
        <template #cell(isActive)="data">
          <b-badge v-if="data.item.purchaseInvoiceItems.isActive" variant="primary">
            Active
          </b-badge>
          <b-badge v-else variant="danger"> Inactive </b-badge>
        </template>
        <!-- <template #cell(orderType)="data">
          <b-badge v-if="data.item.orderType === 0" variant="primary">
            Fixed Order
          </b-badge>
          <b-badge v-else-if="data.item.orderType === 1" variant="primary">
            Variable Order
          </b-badge>
          <b-badge v-else-if="data.item.orderType === 2" variant="primary">
            OneOff Order
          </b-badge>
        </template> -->
        <template #cell(status)="data">
          <b-badge v-if="data.item.status === 0" variant="info"> New </b-badge>
          <b-badge v-else-if="data.item.status === 1" variant="primary">
            Completed
          </b-badge>
          <b-badge v-else-if="data.item.status === 2" variant="danger">
            Cancelled
          </b-badge>
          <b-badge v-else variant="danger"> Blocked </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item :to="getPurchaseOrderId(data.item.id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="data.item.status === 0" @click="getPurchaseInvoiceIdComplete(data.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />

              <span>Complete</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.status === 0"
              @click="CancelPO(data.item)"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Cancel</span>
            </b-dropdown-item>
            <b-dropdown-item @click="viewPurchaseInvoiceDocuments(data.item)">
              <feather-icon icon="PaperclipIcon" />
              <span class="align-middle ml-50">Documents</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>

    <b-col md="3" class="d-flex justify-content-end">
      <b-modal ref="modal-view-purchase-invoice-document" id="modal-view-purchase-invoice-document" ok-only
        ok-title="View" centered size="lg" title="View Purchase Invoice Documents" :hide-footer="true">
        <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
          :documentDetails="documentDetails" />
      </b-modal>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import { deletePurchaseInvoiceDocument, uploadPurchaseInvoiceMultipleDocuments, uploadPurchaseInvoiceDocument, downloadPurchaseInvoiceDocument } from '@/store/purchaseinvoice/services';
import { customSwal, customError } from '@/libs/customFn';

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    DocumentUpload,
    DatePicker
  },
  data() {
    return {
      supplierName: "",
      purchaseOrderData: [],
      fileSizeError: null,
      perPage: 5,
      dayjs,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      filters: {
        orderNumber: "",
        supplierName: "",
        warehouseName: "",
        status: null,
        issueDate: null,
        createdOn: null
      },
      fields: [
        { key: "orderNumber", label: "ORDER NUMBER", sortable: true },
        { key: "supplierName", label: "SUPPLIER NAME", sortable: true },
        { key: "warehouseName", label: "WAREHOUSE NAME", sortable: true },
        { key: "issueDate", label: "ISSUE DATE", sortable: true },
        { key: "createdOn", label: "CREATED ON", sortable: true },
        { key: "status", label: "STATUS", sortable: true },
        { key: "total", label: "TOTAL", sortable: true },
        "actions",
      ],
      statusOptions: [
        { value: null, text: "All" },
        { value: 0, text: "New" },
        { value: 1, text: "Completed" },
        { value: 2, text: "Cancelled" },
      ],
      documentDetails: {
        isDelete: false,
        documentList: []
      },
      PInvoiceId: "",
      documents: []
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("purchaseInvoiceModule", {
      purchaseinvoices: "purchaseinvoices",
      purchaseinvoiceId: "purchaseinvoiceId",
      loading: "loading",
      documentsInvoice: "documents",
      file: "file",
    }),

    ...mapGetters("purchaseOrderModule", {
      loading: "loading",
      documentsOrder: "documents",
      file: "file",
    }),
    ...mapGetters("supplierModule", {
      supplierList: "suppliers",
      supplierLoading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),

    filteredPurchaseInvoices() {
      let PIList = this.purchaseinvoices.filter((invoice) => {
        // Filter by Order Number
        const matchesOrderNumber = this.filters.orderNumber
          ? invoice.orderNumber && invoice.orderNumber.toString().toLowerCase().includes(this.filters.orderNumber.toLowerCase())
          : true;

        // Filter by Supplier Name
        const supplierName = invoice.supplierName || "";
        const matchesSupplierName = this.filters.supplierName
          ? supplierName.toLowerCase().includes(this.filters.supplierName.toLowerCase())
          : true;

        // Filter by Warehouse Name
        const warehouseName = invoice.warehouseName || "";
        const matchesWarehouseName = this.filters.warehouseName
          ? warehouseName.toLowerCase().includes(this.filters.warehouseName.toLowerCase())
          : true;

        // Filter by Status
        const matchesStatus = this.filters.status !== null
          ? invoice.status === this.filters.status
          : true;

        // Filter by Issue Date (if it's a range filter)
        const matchesIssueDate = this.filters.issueDate && this.filters.issueDate.length === 2
  ? dayjs(invoice.issueDate).isSameOrAfter(this.filters.issueDate[0], 'day') &&
    dayjs(invoice.issueDate).isSameOrBefore(this.filters.issueDate[1], 'day')
  : true;
  


        // Filter by Created On (if it's a range filter)
        const matchesCreatedOn = this.filters.createdOn && this.filters.createdOn.length === 2
          ? dayjs(invoice.createdOn).isSameOrAfter(this.filters.createdOn[0], 'day') &&
          dayjs(invoice.createdOn).isSameOrBefore(this.filters.createdOn[1], 'day')
          : true;

        // Combine all filter conditions
        return (
          matchesOrderNumber &&
          matchesSupplierName &&
          matchesWarehouseName &&
          matchesStatus &&
          matchesIssueDate &&
          matchesCreatedOn
        );
      });

      this.totalRows = PIList.length;
        
      return PIList;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.purchaseinvoices.length;
  },
  methods: {
    getpurchaseOrderData(data) {
      console.log(data);
      this.purchaseOrderData = data;
    },

    async viewPurchaseInvoiceDocuments(purchaseInvoice) {
      try {
        // if(purchaseInvoice.purchaseOrderId == null && this.purchaseinvoiceId.id == null) {
        //   //this.PInvoiceId = '';
        //   console.log(this.purchaseinvoiceId.id);
        //   this.documentDetails.documentList = [];
        //   this.$refs["modal-view-purchase-invoice-document"].show();
        // }
       // console.log("purchaseeeeeeeeeeeeee", purchaseInvoice);
         if (purchaseInvoice.purchaseOrderId == null){
          //console.log("111111ssssssssssssssssssssssssssssssssssssssss", purchaseInvoice.id);
          this.PInvoiceId = purchaseInvoice.id
          //console.log("ssssssssssssssssssssssssssssssssssssssss", this.PInvoiceId);
          await this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
       // await this.getPurchaseOrderDocumentListAction(this.PInvoiceId);
        this.documentDetails.documentList = [];
        const purchaseInvoiceDocuments = this.documentsInvoice || [];
       // const purchaseOrderDocuments = this.documentsOrder || [];
        //console.log("👉 purchaseInvoiceDocuments", purchaseInvoiceDocuments);
        //console.log("👉 purchaseOrderDocuments", purchaseOrderDocuments);
        // Merge both document lists
        if (this.documentsInvoice.length > 0) {
          //this.documentDetails.documentList = [...purchaseInvoiceDocuments, ...purchaseOrderDocuments];
          this.documentDetails.documentList = [
  ...(this.documentsInvoice || [])
];
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-purchase-invoice-document"].show();
        }
        else {
          
          this.PInvoiceId = purchaseInvoice.purchaseOrderId;
       
        
        // console.log('referenceId', purchaseInvoice.purchaseOrderId);
        // console.log('PInvoiceId', this.PInvoiceId);
        await this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
        await this.getPurchaseOrderDocumentListAction(this.PInvoiceId);
        this.documentDetails.documentList = [];
        const purchaseInvoiceDocuments = this.documentsInvoice || [];
        const purchaseOrderDocuments = this.documentsOrder || [];
        console.log("👉 purchaseInvoiceDocuments", purchaseInvoiceDocuments);
        console.log("👉 purchaseOrderDocuments", purchaseOrderDocuments);
        // Merge both document lists
        if (this.documentsInvoice.length > 0 || this.documentsOrder.length > 0) {
          //this.documentDetails.documentList = [...purchaseInvoiceDocuments, ...purchaseOrderDocuments];
          this.documentDetails.documentList = [
  ...(this.documentsInvoice || []),
  ...(this.documentsOrder || [])
];
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-purchase-invoice-document"].show();
      }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(downloadById, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadPurchaseInvoiceDocument(downloadById);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },

    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document(s) is being added',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      
      let referenceId = null;
      if(this.PInvoiceId == null){
        console.log("this.purchaseinvoiceId.id", this.purchaseinvoiceId.id);
referenceId = this.purchaseinvoiceId.id;
      }
      else{
        console.log("this.PInvoiceId", this.PInvoiceId);
         referenceId = this.PInvoiceId;
      }

      const maxSize = 20 * 1024 * 1024;
        if (this.selectedFiles && this.selectedFiles.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

      if (selectedFiles.length > 1) {

        await uploadPurchaseInvoiceMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            this.$refs["modal-view-purchase-invoice-document"].hide();
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadPurchaseInvoiceDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal('Your file(s) have been successfully uploaded.');
            this.$refs["modal-view-purchase-invoice-document"].hide();
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getPurchaseInvoiceDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-purchase-order-document');
      });
    },
    async deleteFile(deleteById) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being deleted',
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deletePurchaseInvoiceDocument(deleteById)
        .then((response) => {
          loader.close();
          customSwal("File deleted successfully!");
           this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getPurchaseInvoiceDocumentListAction(this.PInvoiceId);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-purchase-invoice-document');
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);

      var formatted_date = `${year}-${month}-${day}`;
      return formatted_date == "1-01-01" ? "-" : formatted_date;
    },
    getPurchaseOrderId(item) {
      return "/purchaseinvoice/view/" + item;
    },
    removePurchaseOrder(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removePurchaseInvoicesAction(id);
          this.$swal({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    CancelPO(item) {
      let payload = {
        id: item.id,
        status: 2,
        supplierId: item.supplierId,
        quantity: item.quantity,
        totalCost: item.totalCost,
        issueDate: item.issueDate,
        balance: item.balance,
        salesPersonId: item.salesPersonId,
        paymentMethod: item.paymentMethod,
        dueDate: item.dueDate,
        orderNumber: item.orderNumber,
        subTotal: item.subTotal,
        discount: item.discount,
        tax: item.tax,
        total: item.total,
        note: item.note,
        warehouseId: item.warehouseId,
        purchaseOrderItems: item.purchaseOrderItems,
      };
      this.updatePurchaseInvoicesAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Purchase Order Cancelled",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.getPurchaseInvoicesListAction();
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Purchase Order Not Cancelled",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        });
    },
    getPurchaseInvoiceIdComplete(item) {
      console.log('complete item:', item)
      let payload = {
        id: item.id,
        status: 1,
        supplierReference: item.supplierReference,
        supplierId: item.supplierId,
        quantity: item.quantity,
        totalCost: item.totalCost,
        issueDate: item.issueDate,
        balance: item.balance,
        salesPersonId: item.salesPersonId,
        paymentMethod: item.paymentMethod,
        dueDate: item.dueDate,
        orderNumber: item.orderNumber,
        subTotal: item.subTotal,
        discount: item.discount,
        tax: item.tax,
        total: item.total,
        note: item.note,
        warehouseId: item.warehouseId,
        purchaseInvoiceItems: item.purchaseInvoiceItems,
      };
      this.updatePurchaseInvoicesAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Purchase Invoice Completed",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
            window.location.reload();
          });
          this.getPurchaseInvoicesListAction();
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Purchase Invoice Not Completed",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        });
    },
    ...mapActions("purchaseInvoiceModule", [
      "getPurchaseInvoicesListAction",
      "removePurchaseInvoicesAction",
      "updatePurchaseInvoicesAction",
      "getPurchaseInvoiceDocumentListAction"
    ]),
    ...mapActions("purchaseOrderModule", [
      "getPurchaseOrderDocumentListAction"
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    ...mapActions("supplierModule", ["getSupplierListAction"]),
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    filterTable() {
      this.currentPage = 1;
    },
    openCalendar(event) {
      event.target.blur();
      event.target.click();

      document.addEventListener('click', this.closeCalendar);
    },
    closeCalendar(event) {
      const datePicker = this.$refs.datePicker;
      if (!datePicker.contains(event.target)) {
        this.$refs.datePicker.hideCalendar();

        document.removeEventListener('click', this.closeCalendar);
      }
    },
    clearFilters() {
      // Resetting all filters
      this.filters = {
        orderNumber: "",
        supplierName: "",
        warehouseName: "",
        status: null,
        issueDate: null,
        createdOn: null
      };
      // Optionally reset the table pagination if needed
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.getSupplierListAction();
    await this.getWarehouseListAction();
    await this.getPurchaseInvoicesListAction();

    this.purchaseinvoices.forEach((z) => {
      const supplier = this.supplierList.find((obj) => obj.id === z.supplierId);
      const warehouse = this.warehouses.find((obj) => obj.id === z.warehouseId);

      this.$set(z, 'supplierName', supplier ? supplier.name : '-');
      this.$set(z, 'warehouseName', warehouse ? warehouse.name : '');
    });
      
    this.totalRows = this.purchaseinvoices.length;
    this.purchaseinvoices = [...this.purchaseinvoices];

    //this.filteredPurchaseInvoices();
  },
};
</script>

<style scoped>
.small-datepicker {
  width: 150px;
}
</style>
